import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { LlmInfo } from "../models/LlmInfo";

export const useGetLlmInfoDetails = () => {
  const {
    data: llmInfoDetails,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<LlmInfo>((response) => new LlmInfo(response));

  const getLlmInfoDetails = async (llmName: string) => {
    await call(`/admin/llm/${llmName}`, "GET");
  };

  return {
    llmInfoDetails,
    getLlmInfoDetails,
    isLoading,
    isFailed,
  };
};
